export const isShortage = (recommendedQuantity = 0, stock = 0) => recommendedQuantity > stock
